import React from "react"
import { Footer } from "./Partials"
import { useSubdomain } from "hooks/useSubdomain"
import Logo from "components/Elements/logos/Logo"
import { NavLink } from "react-router-dom"

export const PublicLayout = ({ children, className, showFooter = true }) => {
    const { currentSubdomain } = useSubdomain()
    return (
        <div className="u-sticky-view">
            <main className={"c-main-content px-5 " + (className ? className : "")}>
                <NavLink to="/" className="u-block p-7">
                    <Logo name={currentSubdomain?.id} defaultColor={true} />
                </NavLink>
                { children }
            </main>
            { showFooter && <Footer /> }
        </div>
    )
}
